import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { MessageBox, PrevNextButton } from "reusableComponents";

const Confirmation = () => {
  const { t } = useTranslation("global");
  const { spaceId } = useParams();
  const navigate = useNavigate();

  return (
    <div className={styles.confirmationPage}>
      {/* <PrevNextButton
        color="nav"
        onNext={() => navigate("/dashboard/spaces")}
        onPrev={() => navigate(`/create-space/step4/${spaceId}`)}
        isIconOnly
      /> */}
      <MessageBox type="success" message={t("provide.confirmation")} />
    </div>
  );
};

export default Confirmation;
